import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import {ReactComponent as EditIcon} from 'assets/icons/editIcon.svg';
import {ReactComponent as DeleteIcon} from 'assets/icons/delete.svg';
import IconButton from '@material-ui/core/IconButton';
import { COUNT_TYPE } from 'constant/essay';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 8,
    width: '100%',
    
  },
  essay: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: 4,
    lineHeight:1.3,
    marginLeft:10
  },
  newTabIcon: {
    fontSize: 14,
  },
}));

export default function TransitionsModal({
  doc,
  onUpdate,
  onDelete,
  readOnly,
}) {
  const classes = useStyles();

  const onEdit = () => {
    onUpdate(doc);
  };

  return (
    <div className={classes.row}>
      {readOnly ? (
        <Typography variant="subtitle2" className={classes.essay}>
          {doc.filename}{' '}
        </Typography>
      ) : (
        <>
          <Typography
            variant="subtitle2"
            className={classes.essay}
            component="a"
            target="_blank"
            href={doc.url}
          >
            {doc.filename}{' '}
            {doc.word_count &&
              ` - ${doc.word_count} ${
                COUNT_TYPE.find((f) => f.value === doc.count_type)?.label
              }`}
          </Typography>
          <IconButton size="small" target="_blank" href={doc.url}>
            {' '}
            <OpenInNewIcon className={classes.newTabIcon} color="action" />
          </IconButton>{' '}
        </>
      )}
      {!readOnly && (
        <Box marginLeft="auto">
          {onUpdate && (
            <IconButton style={{minWidth: '45px'}} size="small" onClick={onEdit}>
              <EditIcon />
            </IconButton>
          )}
          {onDelete && (
            <IconButton size="small" onClick={() => onDelete(doc)}>
              <DeleteIcon/>
            </IconButton>
          )}
        </Box>
      )}
    </div>
  );
}
